'use client';
// import { Box } from '@fastlooptech/layout-components';
import React from 'react';
import { Display } from '@/client/foundations/Typography';
import classNames from 'classnames';
import { useResponsive } from "@/client/hooks/useResponsive";
import { Box } from '@/layouts/LayoutComponents';
import ImageWrapper from "@/components/ImageWrapper";

export interface LandingProps {
        /**
         * The heading of the Landing.
         * @type string
         * @required
         */
        heading: string;
        /**
         * The image source used as background of the Landing.
         * @type string
         * @required
         */
        image: string;
}

export function LandingImage(props: LandingProps) {
        const { isMd } = useResponsive();

        return (
                <Box
                        component="section"
                        hAlignContent="center"
                        vAlignContent="center"
                        className={classNames(
                                'px-landing-image relative rounded-landing-image',
                                isMd ? '!min-h-[829px]' : ''
                        )}
                >
                        <ImageWrapper
                                src={props.image ? props.image : 'https://placehold.co/800x500'}
                                alt="landing-bg"
                                placeholder="blur"
                                blurDataURL={props.image ? props.image : 'https://placehold.co/800x500'}
                                fill
                                sizes="100vw"
                                priority
                                // loading="lazy"
                                loader={({ src }) => src}
                                className="absolute object-cover aspect-16/9"
                        />
                        <Display
                                size="xl"
                                component="h1"
                                color="text-base-white"
                                className={classNames(
                                        "relative text-center break-normal",
                                        !isMd ? "py-14" : "max-w-[1300px]"
                                )}
                        >
                                {props.heading}
                        </Display>
                </Box>
        );
}
